
<mat-form-field [appearance]="appearance()" [class]="class()">
  <mat-icon matPrefix class="mr1">search</mat-icon>
  <mat-label>{{ translatedLabel }}</mat-label>
  <input matInput type="text" [formControl]="control()" minlength="1" maxlength="150" required autocomplete="off" [matAutocomplete]="companyAutoComplete">
  <div matSuffix="" class="flex items-center">
    @if (isSearchingCompanies) {
      <mat-spinner diameter="24" class="mx2"></mat-spinner>
    }
  </div>
  <mat-autocomplete autoActiveFirstOption #companyAutoComplete="matAutocomplete" [displayWith]="displayCompanySearchResult" >
    @for (companySearchResult of companySearchResults; track companySearchResult) {
      <mat-option [value]="companySearchResult">
        {{ companySearchResult.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
